<ct-lib-progress-ring
  [value]="33.33"
  [label]="false"
  [color]="color"
></ct-lib-progress-ring>
